import { stimulusApplication } from "web-ui/controllers"

function closeModalDialog() {
  const dialog = document.querySelector("dialog")

  const controller = stimulusApplication.getControllerForElementAndIdentifier(
    dialog,
    "modal-dialog"
  )

  if (!controller) {
    return
  }

  controller.closeAndRemove()
}

export function activate(Turbo) {
  Turbo.StreamActions.close_modal_dialog = closeModalDialog
}
